import { NgxRolesService } from 'ngx-permissions';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { } from '@types/googlemaps';
import { HttpParams, HttpClient } from '@angular/common/http';
import { AuthService } from '../../../services/auth.service';
import * as moment from 'moment';
import { Select2OptionData } from 'ng2-select2';
import { OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


declare const google: any;
export const MY_MOMENT1_FORMATS = {
  parseInput: 'YYYY-MM-DD HH:mm:ss',
  fullPickerInput: 'DD/MM/YYYY à HH:mm:ss',
  datePickerInput: 'DD/MM/YYYY',
  timePickerInput: 'HH:mm',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};
@Component({
  selector: 'app-bus-map-journey',
  templateUrl: './bus-map-journey.component.html',
  styleUrls: ['./bus-map-journey.component.css'],
  providers: [{ provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT1_FORMATS }]
})
export class BusMapJourneyComponent implements OnInit {
  @ViewChild('timeline') timelineElement: ElementRef;

  filter = {
    schoolId: 1,
    busIds: [],
    date: new Date(),
    timeInterval: [],
  };
  time = {
    inputFrom: null,
    inputTo: null
  };
  public timeIntervalFrom;
  public timeIntervalTo;
  schools: any[];
  buses: any[];
  currentBus: any;
  map: any;
  markerBounds: any;
  localisations: any[];
  markerAnimated: any;
  animationInterval: any;
  currentStep: number = 0;
  progress: number = 0;
  cursorDragging: boolean = false;
  selectedSpeed: number = 1; // Default playback speed
  isPlaying: boolean = false;
  infowindow: any;
  loadData = true;
  reservedColors = [
    '#3498db',
    '#341f97',
    '#2ecc71',
    '#9b59b6',
    '#34495e',
    '#50000d',
    '#16a085',
    '#c0392b',
    '#34495e',
    '#000000',
  ];

  activeTab: string = 'historique';
  selectedAction: string = 'export'; // Store selected action (import/export)
  archiveDate: string = ''; // Store archive date for export
  selectedFile: File | null = null; // Store selected file

  public schoolsData: Array<Select2OptionData>;
  // ----- Start Option Scrollbar -----------
  isScrollbar: true;
  scrollbarOptions = {
    axis: 'y',
    theme: 'minimal-dark'
  };
  // ----- End Option Scrollbar -----------

  // ----- Start MultiSelect -----------
  optionsModelBus: number[];
  // Settings configuration
  multiSelectSettings: IMultiSelectSettings = {
    enableSearch: false,
    checkedStyle: 'fontawesome',
    showCheckAll: false,
    showUncheckAll: false,
    buttonClasses: 'btn btn-default btn-block btn-position',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true,
    itemClasses: 'MultiSelectItem',
    containerClasses: 'dropdown-block',
    selectionLimit: 1,
    autoUnselect: true,
  };
  // Text configuration
  multiSelectTexts: IMultiSelectTexts = {
    checkAll: 'Tout sélectionner',
    uncheckAll: 'Tout déselectionner',
    checked: 'élément sélectionné',
    checkedPlural: 'éléments sélectionnés',
    searchPlaceholder: 'Trouver',
    searchEmptyResult: 'Rien n\'a été trouvé...',
    searchNoRenderText: 'Tapez dans la boîte de recherche pour voir les résultats ...',
    defaultTitle: 'Sélectionner',
    allSelected: 'Tous sélectionnés',
  };
  // Labels / Parents
  multiSelectBus: IMultiSelectOption[];
  // ----- End MultiSelect -----------
  isResponsible = false;
  withDirection = false;
  lessPosition = false;
   

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private roleService: NgxRolesService,
  ) {
    // fill schools in multiselect
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
    this.fillSchool();
    // const date = Math.floor(new Date().getTime()) - 1000 * 3600;
    // this.time.inputFrom = new Date(date);

    this.time.inputFrom = new Date((6 * 3600 + 30 * 60) * 1000); // 06:30
    this.time.inputTo   = new Date((18 * 3600 + 30 * 60) * 1000); // 18:30
    
    this.setDefaultArchiveDate(); // Set default date for archive journey
  }

  ngOnInit() {
  }

  // this fuction is not used example: this.time.inputFrom = newDateUTC((6 * 3600 + 30 * 60) * 1000); // 06:30
  newDateUTC(infoDate:any){
    var TimeTemp = new Date(infoDate);
    var userTimezoneOffset = TimeTemp.getTimezoneOffset() * 60000;

    return new Date(TimeTemp.getTime() + userTimezoneOffset);
  }

  // Set archive date to today - 60 days
  setDefaultArchiveDate() {
    let today = new Date();
    let pastDate = new Date(today.setDate(today.getDate() - 60));
    this.archiveDate = pastDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
  }

  // Select a file for import
  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
    console.log("File selected:", this.selectedFile);
  }

  // Upload file logic
  onUpload() {
    if (!this.selectedFile) {
      alert("Veuillez sélectionner un fichier.");
      return;
    }
    
    console.log("Uploading file:", this.selectedFile.name);
    // TODO: Add API call to upload file
  }

  // Export file logic
  onExport() {
    if (!this.archiveDate) {
      alert("Veuillez sélectionner une date.");
      return;
    }
    this.loadData = true;
    console.log("Exporting archive for date:", this.archiveDate);
    // TODO: Add API call to fetch and download file
    if (this.filter.schoolId != 0 && this.filter.busIds.length > 0) {
      const selectedDate = new Date(this.archiveDate);
      
      // Force time interval to be from 00:00 to 23:59 using local datetime strings — no timezone conversion
      const exportDateStr = moment(this.archiveDate).format('YYYY-MM-DD');
      const inputFrom = `${exportDateStr} 00:00:00`;
      const inputTo   = `${exportDateStr} 23:59:59`;

      this.filter.timeInterval = [inputFrom, inputTo];

      let params = new HttpParams({
        fromObject: {
          schoolId: this.filter.schoolId + '',
          busIds: JSON.stringify(this.optionsModelBus),
          date: moment(this.archiveDate).format('YYYY-MM-DD'),
          timeInterval: JSON.stringify(this.filter.timeInterval)
        }
      });

      let url = '/api/bus/mapJourney';
      if (this.lessPosition === true){
        url = '/api/bus/mapJourneyligth';
      }
      this.http.get(url, { params })
        .subscribe(
          (data: any) => {

            if (!data.positions.length) {
              this.loadData = false;
              alert("Aucune position trouvée pour cette période.");
              return;
            }

            let excelData: any[] = [];
            
            for (let index = 0; index < data.buses.length; index++) {
              const positions = data.positions.filter(this.getDataFromBus(data.buses[index].id));
              if (positions.length > 0) {
                this.currentBus = data.buses[index];

                const color = this.getRandomColor(index);
                const BusName = this.currentBus.name;
                const iconeName = this.currentBus.iconeName;

                // Loop through positions and format data for Excel
                positions.forEach((pos: any) => {
                  excelData.push({
                    BusName: BusName,
                    IconeName: iconeName,
                    Color: color,
                    Angle: pos.angle,
                    Latitude: pos.lat,
                    Longitude: pos.lng,
                    Speed: pos.speed,
                    Time: moment.utc(pos.time).format('DD/MM/YYYY à HH:mm:ss')
                  });
                });
              }
            }

            this.loadData = false;

            // Generate Excel file
            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Bus Positions");

            // Save the file
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            saveAs(dataBlob, `bus_positions_${this.currentBus.name}_${moment(this.archiveDate).format('YYYY-MM-DD')}.xlsx`);

          },
          error => {
            this.loadData = false;
          }
        );
    }

  }

  initMap() {
    var center = { lat: 33.906203, lng: -6.9299658 };
    var schoolName = '';
    for (var i = 0; i < this.schools.length; i++) {
      if (this.filter.schoolId == this.schools[i].id) {
        center = { lat: parseFloat(this.schools[i].lat), lng: parseFloat(this.schools[i].lng) };
        schoolName = this.schools[i].name;
        break;
      }
    }
    // map
    this.map = new google.maps.Map(document.getElementById('bus-map'), {
      zoom: 10,
      center: center,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    });
    this.markerBounds = new google.maps.LatLngBounds();
    // school marker
    var schoolInfowindow = new google.maps.InfoWindow({
      content: '<b>Ets : </b>' + schoolName
    });
    var schoolMarker = new google.maps.Marker({
      position: center,
      map: this.map,
      icon: 'assets/images/markers/school.png',
      // zIndex: 99
    });
    // this.markerBounds.extend(center);
    schoolMarker.addListener('click', function () {
      schoolInfowindow.open(this.map, schoolMarker);
    });
    schoolMarker.addListener('mouseover', function() {
      schoolInfowindow.open(this.map, schoolMarker);
    });
    schoolMarker.addListener('mouseout', function() {
      schoolInfowindow.close();
    });
  }

  fillSchool() {
    // add schools in multiselect
    let client = this.auth.getUser();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      client = this.auth.getUser().School.Client;
    }
    let params = new HttpParams({
      fromObject: {
        clientId: client.id,
      }
    });

    this.http.get('/api/school/lookup', { params })
      .subscribe(
        (schools: any[]) => {
          if (schools.length) {
            this.schools = schools;
            this.schoolsData = this.schools.map(function (school, index) {
              return { id: school.id, text: school.name };
            });
            // this.filter.schoolId = this.schools[0].id;
            // this.initMap();
            // this.fillbus();
          }
        }
      );
  }

  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initMap();
    this.fillbus();
  }

  fillbus() {
    this.optionsModelBus = [];
    let client = this.auth.getUser();
    let schoolId = this.filter.schoolId;
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      client = this.auth.getUser().School.Client;
      schoolId = this.auth.getUser().School.id;
    }
    let params = new HttpParams({
      fromObject: {
        clientId: client.id,
        schoolId: schoolId + ''
      }
    });
    this.http.get('/api/bus/lookup', { params })
      .subscribe(
        (bus: any[]) => {
          this.multiSelectBus = bus;
          if (this.multiSelectBus.length) {
            this.optionsModelBus.push(this.multiSelectBus[0].id);
            for (let i = 0; i < this.multiSelectBus.length; i++) {
              this.filter.busIds.push(this.multiSelectBus[i].id);
            }
            this.loadData = false;
          }
        }
      );
  }

  onSchoolChange() {
    this.fillbus();
  }

  getDataFromBus(id) {
    return function (element) {
      return element.busId === id;
    };
  }

  onFilter() {
    this.loadData = true;
    this.initMap();
    
    if (this.markerAnimated) {
      this.markerAnimated.setMap(null); // if exist, remove the marker from the map
      this.markerAnimated = null; // Clear the reference
    }

    if (this.filter.schoolId != 0 && this.filter.busIds.length > 0) {
      //const inputFrom = Math.floor(new Date(this.time.inputFrom).getTime() / 1000);
      //const inputTo = Math.floor(new Date(this.time.inputTo).getTime() / 1000);
      //this.filter.timeInterval = [inputFrom, inputTo];

      // Ensure the selected date is correctly set to archiveDate
      const selectedDate = new Date(this.filter.date);

      // Extract hours and minutes from the inputs
      const fromHours = new Date(this.time.inputFrom).getHours();
      const fromMinutes = new Date(this.time.inputFrom).getMinutes();
      const toHours = new Date(this.time.inputTo).getHours();
      const toMinutes = new Date(this.time.inputTo).getMinutes();

      // Build local datetime strings directly — no timezone conversion
      const dateStr = moment(selectedDate).format('YYYY-MM-DD');
      const fromStr = `${dateStr} ${String(fromHours).padStart(2, '0')}:${String(fromMinutes).padStart(2, '0')}:00`;
      const toStr   = `${dateStr} ${String(toHours).padStart(2, '0')}:${String(toMinutes).padStart(2, '0')}:59`;

      this.filter.timeInterval = [fromStr, toStr];

      let params = new HttpParams({
        fromObject: {
          schoolId: this.filter.schoolId + '',
          busIds: JSON.stringify(this.optionsModelBus),
          date: moment(this.filter.date).format('YYYY-MM-DD'),
          timeInterval: JSON.stringify(this.filter.timeInterval)
        }
      });

      let url = '/api/bus/mapJourney';
      if (this.lessPosition === true){
        url = '/api/bus/mapJourneyligth';
      }
      this.http.get(url, { params })
        .subscribe(
          (data: any) => {

            if (!data.positions.length) {
              this.loadData = false;
            }
            for (let index = 0; index < data.buses.length; index++) {
              const positions = data.positions.filter(this.getDataFromBus(data.buses[index].id));
              if (positions.length > 0) {
                const color = this.getRandomColor(index);
                this.createLineBus(data.buses[index], positions, this.map, color);
                this.localisations = positions;
                this.currentBus = data.buses[index];
              }
            }
            this.map.fitBounds(this.markerBounds);
          },
          error => {
            this.loadData = false;
          }
        );
    }
  }

  // Method to start the playback animation
  startPlayback() {
    console.log('Start animation');

    // Check if markerAnimated doesn't exist, then create it
    if (!this.markerAnimated) {
      let icon;
      const infowindow = new google.maps.InfoWindow();
      let content = '';

      /* if (this.currentBus.iconeName === "Colis" || this.currentBus.iconeName === "Ruche"){
        icon = 'assets/images/markers/'+this.currentBus.iconeName+'/'+this.currentBus.iconeName+'-marker.png'
      } else {
        icon = 'assets/images/markers/'+this.currentBus.iconeName+'/'+this.currentBus.iconeName+'-marker_'+this.localisations[this.currentStep].angle+'.png';
      } */

      this.markerAnimated = new google.maps.Marker({
        position: new google.maps.LatLng(this.localisations[this.currentStep].lat, this.localisations[this.currentStep].lng),
        map: this.map,
        //icon: icon
        icon: {
          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          scale: 4,
          fillColor: '#333333',
          fillOpacity: 0.9,
          rotation: this.localisations[this.currentStep].angle,
        }
      });

      const this_ = this;
      this.markerAnimated.addListener('click', function () {
        const pos = this_.localisations[this_.currentStep];
        const position = pos.lat + ',' + pos.lng;

        content = `<b>Véhicule :</b> ${this_.currentBus.name}<br/>
        <b>Date :</b> ${ moment.utc(pos.time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
        <b>Position :</b> ${position} <br/>
        <b>Vitesse :</b> ${pos.speed} km/h<br/>
        <b>Kilometrage :</b> ${pos.mileage} km<br/>
        <b>Signal GSM :</b> ${pos.gsmSignalStrength}/5<br>
        <b>Batterie :</b> ${pos.extBattery > 0 ? `<label style="color:green">Connecté</label>`
        : `<label style="color:orange">Déconnecté</label>`}<br>`;
    
        content += (pos.BusEvent) ? `<b>Message :</b> ${pos.BusEvent.message}` : '';

        if (this_.roleService.getRole('ROLE_SUPER_CLIENT')) {
          const bus = this_.currentBus;
          content += `<b>Alerte mouvement :</b> ${pos.alertMouvement ? 'Oui' : 'Non'}<br/>`;
          content += `<b>Batterie interne :</b> ${(pos.intBattery / 1000).toFixed(2)} V<br/>`;
          content += `<b>IMEI :</b> ${bus.imei || '-'}<br/>`;
          content += `<b>SIM Tracker :</b> ${bus.simTracker || '-'}<br/>`;
          content += `<b>Expiration SIM :</b> ${bus.simExpiration ? moment(bus.simExpiration).format('DD/MM/YYYY') : '-'}<br/>`;
        }

        infowindow.setContent(content);
        infowindow.open(this_.map, this_.markerAnimated);
      });

      this.infowindow = infowindow;
    }

    // Start animation interval
    this.animationInterval = setInterval(() => {
      console.log('currentStep', this.currentStep);
      //console.log('localisations', this.localisations.length - 1);
      if (this.currentStep < this.localisations.length - 1) {
        this.currentStep++;
        this.updateMarkerPosition();
      } else {
        //this.stopPlayback();
        this.currentStep = 0;
        this.togglePlayback();
        this.markerAnimated.setMap(null); // remove the marker from the map
        this.markerAnimated = null; // Clear the reference
      }
    }, 1000); // Animation interval in milliseconds
  }

  updateMarkerPosition() {
    let icon;
    
    /* if (this.currentBus.iconeName === "Colis" || this.currentBus.iconeName === "Ruche"){
      icon = 'assets/images/markers/'+this.currentBus.iconeName+'/'+this.currentBus.iconeName+'-marker.png'
    } else {
      icon = 'assets/images/markers/'+this.currentBus.iconeName+'/'+this.currentBus.iconeName+'-marker_'+this.localisations[this.currentStep].angle+'.png';
    } */

    const newPosition = new google.maps.LatLng(this.localisations[this.currentStep].lat, this.localisations[this.currentStep].lng);
    const newAngle = this.localisations[this.currentStep].angle;
    
    this.markerAnimated.setPosition(newPosition);
    // this.markerAnimated.setIcon(icon);

    this.markerAnimated.setIcon({
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      scale: 4,
      fillColor: '#333333',
      fillOpacity: 0.9,
      rotation: newAngle,
    });

    // Check if the infowindow is open before updating info
    if (this.infowindow.getMap()) {
      const pos = this.localisations[this.currentStep];
      const position = pos.lat + ',' + pos.lng;

      let content = `<b>Véhicule :</b> ${this.currentBus.name}<br/>
            <b>Date :</b> ${ moment.utc(pos.time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
            <b>Position :</b> ${position} <br/>
            <b>Vitesse :</b> ${pos.speed} km/h<br/>
            <b>Kilometrage :</b> ${pos.mileage} km<br/>
            <b>Signal GSM :</b> ${pos.gsmSignalStrength}/5<br>
            <b>Batterie :</b> ${pos.extBattery > 0 ? `<label style="color:green">Connecté</label>`
            : `<label style="color:orange">Déconnecté</label>`}<br>`;
        
      content += (pos.BusEvent) ? `<b>Message :</b> ${pos.BusEvent.message}` : '';

      if (this.roleService.getRole('ROLE_SUPER_CLIENT')) {
        const bus = this.currentBus;
        content += `<b>Alerte mouvement :</b> ${pos.alertMouvement ? 'Oui' : 'Non'}<br/>`;
        content += `<b>Batterie interne :</b> ${(pos.intBattery / 1000).toFixed(2)} V<br/>`;
        content += `<b>IMEI :</b> ${bus.imei || '-'}<br/>`;
        content += `<b>SIM Tracker :</b> ${bus.simTracker || '-'}<br/>`;
        content += `<b>Expiration SIM :</b> ${bus.simExpiration ? moment(bus.simExpiration).format('DD/MM/YYYY') : '-'}<br/>`;
      }

      // Update the content of the stored infowindow
      this.infowindow.setContent(content);
    }
    

    // You can also update the timeline progress here if needed
    this.progress = (this.currentStep / (this.localisations.length - 1)) * 100;

  }

  // Method to stop the playback animation
  stopPlayback() {
    // Implement your logic to stop the animation
    clearInterval(this.animationInterval);
    this.animationInterval = null;
  }

  getCursorPercentage(): number {
    if (this.localisations && this.localisations.length > 1) {
      let getCursorPercentage_ = (this.currentStep / (this.localisations.length - 1)) * 100;
      //console.log('getCursorPercentage',getCursorPercentage_);
      return (this.currentStep / (this.localisations.length - 1)) * 100;
      
    }
    return 0;
  }

  onCursorDrag(event: MouseEvent) {
    this.cursorDragging = true;
    
    const timelineRect = this.timelineElement.nativeElement.getBoundingClientRect();

    const offsetX = event.clientX - timelineRect.left;
    //console.log('offsetX',offsetX);

    const cursorPercentage = (offsetX / timelineRect.width) * 100;
    //console.log('cursorPercentage',cursorPercentage);
    //console.log('timelineRect.width',timelineRect.width);

    // Ensure cursorPercentage doesn't exceed 100 or go below 0
    const clampedPercentage = Math.max(0, Math.min(100, cursorPercentage));

    this.currentStep = Math.round((clampedPercentage / 100) * (this.localisations.length - 1));

    this.updateMarkerPosition();

    // Listen for mouse move and mouse up events to handle dragging
    const mouseMoveListener = (e: MouseEvent) => this.onCursorMouseMove(e);
    const mouseUpListener = () => this.onCursorMouseUp(mouseMoveListener);

    window.addEventListener('mousemove', mouseMoveListener);
    window.addEventListener('mouseup', mouseUpListener);
  }

  onCursorMouseMove(event: MouseEvent) {
    if (this.cursorDragging) {

      const timelineRect = this.timelineElement.nativeElement.getBoundingClientRect();
      const offsetX = event.clientX - timelineRect.left;

      const cursorPercentage = (offsetX / timelineRect.width) * 100;
      // Ensure cursorPercentage doesn't exceed 100 or go below 0
      const clampedPercentage = Math.max(0, Math.min(100, cursorPercentage));

      this.currentStep = Math.round((clampedPercentage / 100) * (this.localisations.length - 1));

      this.updateMarkerPosition();
    }
  }

  onCursorMouseUp(mouseMoveListener: (e: MouseEvent) => void) {
    this.cursorDragging = false;
    window.removeEventListener('mousemove', mouseMoveListener);
  }

  changePlaybackSpeed() {
    // Update the animation interval based on the selected speed
    if (this.animationInterval) {
      clearInterval(this.animationInterval);
      this.animationInterval = setInterval(() => {
        if (this.currentStep < this.localisations.length - 1) {
          this.currentStep++;
          this.updateMarkerPosition();
        } else {
          //this.stopPlayback();
          this.currentStep = 0;
          this.togglePlayback();
          this.markerAnimated.setMap(null); // remove the marker from the map
          this.markerAnimated = null; // Clear the reference
        }
      }, 1000 / this.selectedSpeed); // Adjust the interval based on the selected speed
    }
  }

  togglePlayback() {
    if (this.isPlaying) {
      this.stopPlayback();
    } else {
      this.startPlayback();
    }
    this.isPlaying = !this.isPlaying;
  }


  createLineBus(bus, locations, map, color) {
    const infowindow = new google.maps.InfoWindow();
    const path = [];
    for (let i = 0; i < locations.length; i++) {
      const isFirst = i === 0 ? true : false;
      const isLast = i === locations.length - 1 ? true : false;

      const pos = new google.maps.LatLng(parseFloat(locations[i].lat), parseFloat(locations[i].lng));
      // Because path is an MVCArray, we can simply append a new coordinate
      // and it will automatically appear.
      path.push(pos);

      let diffTime = 0;
      let colorCircle = '#F00';
      let colorArrow = color;
      let content = '';
      let label = null;
      let icon = null;

      if (this.roleService.getRole('ROLE_SUPER_CLIENT')) {
        // calcule difftime
        diffTime = this.calculateTimeDifferenceInSeconds(locations[i].time,locations[i].timeReceived);
        if (locations[i].alertMouvement === 1){
          if (diffTime < 6 ){
            colorCircle = '#7CFC00';
            colorArrow  = '#7CFC00';
          } else if (diffTime < 12){
            colorCircle = '#ff7f00 ';
            colorArrow  = '#ff7f00 ';
          } else {
            colorCircle = '#F00';
            colorArrow  = '#F00';
          }
        } else {
          if (diffTime < 15 ){
            colorCircle = '#7CFC00';
            colorArrow  = '#7CFC00';
          } else {
            colorCircle = '#F00';
            colorArrow  = '#F00';
          }
        }
      }

      if (isFirst && i === 0) {
        content = '<h1 style="text-align: center;">Départ</h1>';
        label = 'D';
      } else if (isLast && i === locations.length - 1) {
        content = '<h1 style="text-align: center;">Arrivée</h1>';
        label = 'A';
      } else if (locations[i].speed === 0) {
        icon = {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 6,
            strokeColor: '#ffffff',
            strokeWeight: 2,
            fillColor: colorCircle,
            fillOpacity: 0.9
        };
      } else {
        icon = {
            // url: this.createMarkerColored(color, locations[i].BusEvent),
            // origin: new google.maps.Point(0, 0),
            // anchor: new google.maps.Point(15, 15),
            // flat: true
            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            scale: 4.5,
            strokeColor: '#ffffff',
            strokeWeight: 1.5,
            fillColor: colorArrow,
            fillOpacity: 0.9,
            rotation: locations[i].angle
        };
      }
      // this.roleService.getRole('ROLE_SUPER_CLIENT')
      if (this.withDirection === true || (isFirst && i === 0) || isLast && i === locations.length - 1 ) {
        // window.alert(locations[i].angle);
        const marker = new google.maps.Marker({
          position: pos,
          map: map,
          label: label,
          icon: icon
        });
        this.markerBounds.extend(pos);

        const this_ = this;
        marker.addListener('click', function () {
          const position = locations[i].lat + ',' + locations[i].lng;

          content = `<b>Véhicule :</b> ${bus.name}<br/>
          <b>Date :</b> ${ moment.utc(locations[i].time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
          <b>Position :</b> ${position} <br/>
          <b>Vitesse :</b> ${locations[i].speed} km/h<br/>
          <b>Kilometrage :</b> ${locations[i].mileage} km<br/>
          <b>Signal GSM :</b> ${locations[i].gsmSignalStrength}/5<br>
          <b>Batterie :</b> ${locations[i].extBattery > 0 ? `<label style="color:green">Connecté</label>`
          : `<label style="color:orange">Déconnecté</label>`}<br>`;
      
          content += (locations[i].BusEvent) ? `<b>Message :</b> ${locations[i].BusEvent.message}` : '';
          if (this_.roleService.getRole('ROLE_SUPER_CLIENT')) {
            content += `<b>Time received :</b> ${locations[i].timeReceived}<br/>`;
            content += `<b>Alerte mouvement :</b> ${locations[i].alertMouvement ? 'Oui' : 'Non'}<br/>`;
            content += `<b>Batterie interne :</b> ${(locations[i].intBattery / 1000).toFixed(2)} V<br/>`;
            content += `<b>IMEI :</b> ${bus.imei || '-'}<br/>`;
            content += `<b>SIM Tracker :</b> ${bus.simTracker || '-'}<br/>`;
            content += `<b>Expiration SIM :</b> ${bus.simExpiration ? moment(bus.simExpiration).format('DD/MM/YYYY') : '-'}<br/>`;
          }

          infowindow.setContent(content);
          infowindow.open(map, marker);
        });

        marker.addListener('mouseover', function() {
          content = `<b>Véhicule :</b> ${bus.name}<br/>
          <b>Date :</b> ${ moment.utc(locations[i].time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
          <b>Vitesse :</b> ${locations[i].speed} km/h<br/>
          <b>Kilometrage :</b> ${locations[i].mileage} km<br/>
          `;

          content += (locations[i].BusEvent) ? `<b>Message :</b> ${locations[i].BusEvent.message}` : '';
          if (this_.roleService.getRole('ROLE_SUPER_CLIENT')) {
            content += `<b>Time received :</b> ${locations[i].timeReceived}<br/>`;
            content += `<b>Alerte mouvement :</b> ${locations[i].alertMouvement ? 'Oui' : 'Non'}<br/>`;
            content += `<b>Batterie interne :</b> ${(locations[i].intBattery / 1000).toFixed(2)} V<br/>`;
            content += `<b>IMEI :</b> ${bus.imei || '-'}<br/>`;
            content += `<b>SIM Tracker :</b> ${bus.simTracker || '-'}<br/>`;
            content += `<b>Expiration SIM :</b> ${bus.simExpiration ? moment(bus.simExpiration).format('DD/MM/YYYY') : '-'}<br/>`;
          }

          infowindow.setContent(content);
          infowindow.open(map, marker);
        });
        marker.addListener('mouseout', function() {
          infowindow.close();
        });
      }

      if (isLast) {
        this.loadData = false;
      }
    }
    const poly = new google.maps.Polyline({
      path: path,
      geodesic: true,
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: 3,
      // icons: [{
      //   icon: { path: google.maps.SymbolPath.FORWARD_OPEN_ARROW },
      //   offset: '10%',
      //   repeat: '500px'
      // }]
    });
    poly.setMap(map);

  }

  calculateTimeDifferenceInSeconds(time1, time2) {
    time1 = moment(time1).format('DD/MM/YYYY à HH:mm:ss');
    time2 = moment(time2).format('DD/MM/YYYY à HH:mm:ss');
    const momentTime1 = moment(time1, 'DD/MM/YYYY à HH:mm:ss');
    const momentTime2 = moment(time2, 'DD/MM/YYYY à HH:mm:ss');
    
    const diffInSeconds = momentTime2.diff(momentTime1, 'seconds');
    
    console.log('diffInSeconds', diffInSeconds);
    
    return diffInSeconds;
  }


  changeTimeFrom() {
    // const h = 3600;
    // const inputFrom = Math.floor(new Date(this.time.inputFrom).getTime() / 1000);
    // const inputTo = Math.floor(new Date(this.time.inputTo).getTime() / 1000);
    // this.timeIntervalFrom = inputFrom;

    // if (inputFrom >= inputTo) {
    //   this.time.inputTo = new Date((inputFrom + h) * 1000);

    // } else {
    //   if (inputTo - inputFrom > h) {
    //     this.timeIntervalTo = inputFrom + h;
    //     this.time.inputTo = new Date(this.timeIntervalTo * 1000);
    //   }
    // }
  }

  changeTimeTo() {
    // const h = 3600;
    // const inputFrom = Math.floor(new Date(this.time.inputFrom).getTime() / 1000);
    // const inputTo = Math.floor(new Date(this.time.inputTo).getTime() / 1000);
    // this.timeIntervalTo = inputTo;
    // if (inputFrom >= inputTo) {
    //   this.time.inputFrom = new Date((inputTo - h) * 1000);
    // } else {
    //   if (inputTo - inputFrom > h) {
    //     this.timeIntervalFrom = inputTo - h;
    //     this.time.inputFrom = new Date(this.timeIntervalFrom * 1000);
    //   }
    // }
  }

  getRandomColor(i) {
    return this.reservedColors[i % 9];
  }

  createMarkerColored(color, event = false) {
    const width = 15;
    const height = 15;
    const radius = 8;
    let canvas, context1, context2;

    canvas = document.createElement("canvas");
    context1 = canvas.getContext("2d");
    canvas.width = width * 2;
    canvas.height = height * 2;

    context1.fillStyle = color;
    context1.strokeStyle = (event) ? '#ff8000' : '#fff';
    context1.beginPath();
    context1.arc(width, height, radius, 0, 2 * Math.PI);
    context1.lineWidth = 3;
    context1.closePath();
    context1.fill();
    context1.stroke();

    return canvas.toDataURL();

  }


}



// WEBPACK FOOTER //
// ./src/app/components/bus/bus-map-journey/bus-map-journey.component.ts